/**
 * Composant bouton d'export CSV des clients
 * Affiche la progression pendant l'export
 */

import React from "react";
import useClientExport from "./hooks/useClientExport";

const ExportClientButton = () => {
  const { isExporting, exportProgress, exportAllClients } = useClientExport();

  return (
    <div className="d-inline-block ml-2">
      <button
        className="btn btn-success"
        onClick={exportAllClients}
        disabled={isExporting}
        title="Exporter tous les clients au format CSV"
      >
        {isExporting ? (
          <>
            <i className="fas fa-spinner fa-spin mr-2" />
            Export en cours... ({exportProgress.current}/{exportProgress.total})
          </>
        ) : (
          <>
            <i className="fas fa-file-csv mr-2" />
            Exporter CSV
          </>
        )}
      </button>
    </div>
  );
};

export default ExportClientButton;
